export const PRODUCT_TYPE_META: ProductTypeMeta = {
  digital: {
    facets: [
      {
        key: 'subscriptionFrequency',
        priority: 1,
        title: 'facet-title-subscriptionFrequency',
        layout: 'subscriptionFrequency',
      },
    ],
    maxQuantity: 1,
  },
  nutrition: {
    facets: [
      {
        key: 'flavor',
        priority: 1,
        title: 'facet-title-flavor',
        layout: 'default',
      },
      {
        key: 'keyIngredient',
        priority: 2,
        title: 'facet-title-keyIngredient',
        layout: 'default',
      },
      {
        key: 'packaging',
        priority: 3,
        title: 'facet-title-packaging',
        layout: 'default',
      },
      {
        key: 'subscriptionFrequency',
        priority: 4,
        title: 'facet-title-subscriptionFrequency',
        layout: 'subscriptionFrequency',
      },
    ],
    maxQuantity: 5,
  },
  fitness: {
    facets: [
      {
        key: 'size',
        priority: 1,
        title: 'facet-title-size',
        layout: 'default',
      },
    ],
    maxQuantity: 5,
  },
}
